<!--
  第四个区域：超级大奖，纯图片
  简体用 cn 目录，其余（繁体 / 英文 / 韩文 / 站外）默认繁体
  图 750x702@2x，满页宽（375px），顶部自带 39px 透明留白
-->
<script lang="ts">
  import { locale } from "svelte-i18n";
  import bigAwardsCn from "../assets/images/cn/big-awards.png";
  import bigAwardsTc from "../assets/images/tc/big-awards.png";

  let src = $derived($locale === "zh-cn" ? bigAwardsCn : bigAwardsTc);
</script>

<img {src} alt="" class="w-full block" />
